(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/debug-ui/assets/javascripts/debug-ui.js') >= 0) return;  svs.modules.push('/components/components/debug-ui/assets/javascripts/debug-ui.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  if (!svs.core.detect.feature('ft-debug-ui')) {
    return;
  }

  var model = {
    components: [
      {
        name: 'Alert',
        cssClass: 'debug-ui-alert'
      },
      {
        name: 'Badge',
        cssClass: 'debug-ui-badge'
      },
      {
        name: 'Button',
        cssClass: 'debug-ui-button'
      },
      {
        name: 'Button bet',
        cssClass: 'debug-ui-btn-bet'
      },
      {
        name: 'Button group',
        cssClass: 'debug-ui-btn-group'
      },
      {
        name: 'Button switch',
        cssClass: 'debug-ui-btn-switch'
      },
      {
        name: 'Checkbox',
        cssClass: 'debug-ui-checkbox-checkmark'
      },
      {
        name: 'Checkbox button',
        cssClass: 'debug-ui-checkbox-button'
      },
      {
        name: 'Icon button',
        cssClass: 'debug-ui-icon-button'
      },
      {
        name: 'List group',
        cssClass: 'debug-ui-list-group'
      },
      {
        name: 'Message box',
        cssClass: 'debug-ui-message-box'
      },
      {
        name: 'Modal',
        cssClass: 'debug-ui-modal'
      },
      {
        name: 'Overlay',
        cssClass: 'debug-ui-overlay'
      },
      {
        name: 'Panel',
        cssClass: 'debug-ui-panel'
      },
      {
        name: 'Radio button',
        cssClass: 'debug-ui-radio-button-item'
      },
      {
        name: 'Radio pill',
        cssClass: 'debug-ui-radio-pill-item'
      },
      {
        name: 'Tab',
        cssClass: 'debug-ui-tab'
      },
      {
        name: 'Tab-view',
        cssClass: 'debug-ui-tab-view'
      },
      {
        name: 'Table',
        cssClass: 'debug-ui-table'
      },
      {
        name: 'Widget',
        cssClass: 'debug-ui-widget'
      },
      {
        name: 'Widget area',
        cssClass: 'debug-ui-widget-area'
      }
    ]
  };

  $('body').append(svs.components.debug_ui.templates.debug_ui_settings(model));

  $('.js-debug-ui-components-all').click(function() {
    $('.js-debug-ui-component')
      .prop('checked', true)
      .trigger('change');
  });

  $('.js-debug-ui-components-none').click(function() {
    $('.js-debug-ui-component')
      .prop('checked', false)
      .trigger('change');
  });

  listen();
  addDebugCSSClasses();
  debugResponsiveImages();

  $('.js-debug-ui-component')
    .change(function(e) {
      var componentCheckbox = $(e.currentTarget),
        componentIndex = componentCheckbox.data('index'),
        component = model.components[componentIndex];

      if (componentCheckbox.prop('checked')) {
        $('body').addClass(component.cssClass);
      } else {
        $('body').removeClass(component.cssClass);
      }
    })
    .prop('checked', true)
    .trigger('change');

  $('.js-debug-ui-tool-grid').change(function(e) {
    var componentCheckbox = $(e.currentTarget);

    if (componentCheckbox.prop('checked')) {
      $('body').append($('<div />').addClass('grid-overlay'));
    } else {
      $('.grid-overlay').remove();
    }
  });

  $('.js-debug-ui-tool-lines').change(function(e) {
    var componentCheckbox = $(e.currentTarget);

    if (componentCheckbox.prop('checked')) {
      $('body')
        .append(
          $('<div />').addClass(
            'overlay-line-x overlay-line-x-1 js-overlay-line-x-1'
          )
        )
        .append(
          $('<div />').addClass(
            'overlay-line-x overlay-line-x-2 js-overlay-line-x-2'
          )
        )
        .append(
          $('<div />').addClass(
            'overlay-line-y overlay-line-y-1 js-overlay-line-y-1'
          )
        )
        .append(
          $('<div />').addClass(
            'overlay-line-y overlay-line-y-2 js-overlay-line-y-2'
          )
        )
        .append($('<div />').addClass('overlay-line-coordinates'))
        .on('mousemove', cursorMove);
    } else {
      $('.overlay-line-x').remove();
      $('.overlay-line-y').remove();
      $('.overlay-line-coordinates').remove();
      $('body').off('mousemove', cursorMove);
    }
  });

  function cursorMove(e) {
    var $window = $(window),
      width = $window.width(),
      height = $window.height();

    $('.js-overlay-line-x-1').css({
      top: e.pageY - $(document).scrollTop(),
      right: width - e.pageX + 2
    });
    $('.js-overlay-line-x-2').css({
      top: e.pageY - $(document).scrollTop(),
      left: e.pageX + 2
    });

    $('.js-overlay-line-y-1').css({
      left: e.pageX - $(document).scrollLeft(),
      bottom: height - e.pageY + 2
    });

    $('.js-overlay-line-y-2').css({
      left: e.pageX - $(document).scrollLeft(),
      top: e.pageY + 2
    });

    $('.overlay-line-coordinates')
      .css(
        'transform',
        'translate3d(' +
          (e.pageX + 1 - $(document).scrollLeft()) +
          'px, ' +
          (e.pageY - 12 - $(document).scrollTop()) +
          'px, 0)'
      )
      .text(e.pageX + 'x' + e.pageY);
  }

  function addDebugCSSClasses() {
    $('.btn-label:has(.btn-toggle-checkmark)').addClass(
      'debug-ui-checkbox-checkmark-item'
    );
    $('.btn-label:has(.btn-toggle-300):has(input[type=checkbox])').addClass(
      'debug-ui-checkbox-button-item'
    );
    $('.btn-label:has(.btn-toggle-300):has(input[type=radio])').addClass(
      'debug-ui-radio-button-item'
    );
    $('.btn-label:has(.btn-toggle-100):has(input[type=radio])').addClass(
      'debug-ui-radio-pill-item'
    );
  }

  function debugResponsiveImages() {
    $('.responsive-image-wrapper').each(function() {
      var $item = $(this);
      $item.find('.responsive-image').on('load', function() {
        setSizeLabel($item);
      });
    });
  }

  function setSizeLabel($item) {
    var src = $item.find('.responsive-image').get(0).currentSrc;
    var size;

    if (src.indexOf('-320.') > -1) {
      size = '320 x 140';
    } else if (src.indexOf('-480.') > -1) {
      size = '480 x 210';
    } else if (src.indexOf('-640.') > -1) {
      size = '640 x 280';
    } else if (src.indexOf('-800.') > -1) {
      size = '800 x 350';
    } else if (src.indexOf('-960.') > -1) {
      size = '960 x 420';
    } else if (src.indexOf('-1120.') > -1) {
      size = '1120 x 490';
    } else if (src.indexOf('-1280.') > -1) {
      size = '1280 x 560';
    }

    if (size !== undefined) {
      var $sizeLabel = $item.find('.debug-ui-responsive-image-size-label');
      if (!$sizeLabel.length) {
        $sizeLabel = $('<div/>', {
          class: 'debug-ui-responsive-image-size-label'
        }).appendTo($item);
      }
      $sizeLabel.text(size);
    }
  }

  function listen() {
    var mutSrv = window.MutationObserver || window.WebKitMutationObserver,
      evtSupp = window.addEventListener,
      domChangeTimeoutIndex = null,
      domChangeTimeout = 100,
      rootEl = document.body;

    if (mutSrv) {
      var obs = new mutSrv(function(mutations) {
        var i = mutations.length;
        while (i) {
          i--;

          if (mutations[i].addedNodes) {
            i = 0;

            window.clearTimeout(domChangeTimeoutIndex);

            domChangeTimeoutIndex = window.setTimeout(function() {
              addDebugCSSClasses();
              debugResponsiveImages();
            }, domChangeTimeout);
          }
        }
      });
      obs.observe(rootEl, {
        childList: true,
        subtree: true,
        attributes: false
      });
    } else if (evtSupp) {
      document.body.addEventListener(
        'DOMNodeInserted',
        function() {
          window.clearTimeout(domChangeTimeoutIndex);

          domChangeTimeoutIndex = window.setTimeout(function() {
            addDebugCSSClasses();
            debugResponsiveImages();
          }, domChangeTimeout);
        },
        false
      );
    }
  }
})(svs);

 })(window);